/**
 * Regex for validating email addresses.
 * TODO: Possible unsafe regexp, see sonarjs error below for more info.
 */
// eslint-disable-next-line sonarjs/super-linear-regex
export const EMAIL_VALIDATION_REGEX = /^\S+@\S+\.[^\s\d]{2,}$/u;

/** The maximum length of the username. */
export const USERNAME_MAX_LENGTH = 99;

/** Regex for validating usernames. */
export const USERNAME_VALIDATION_REGEX = new RegExp(String.raw`^[\d_a-z-]{1,${USERNAME_MAX_LENGTH}}$`, "u");

/** The count of the username ID digits. */
export const USERNAME_ID_LENGTH = 3;

/** Regexp for validating username IDs. */
export const USERNAME_ID_VALIDATION_REGEX = new RegExp(`^[0-9]{${USERNAME_ID_LENGTH}}$`, "u");

/** Minimum password length for user accounts. */
export const PASSWORD_MIN_LENGTH = 6;

/**
 * Validate the form of a device linking code, this is just base32 without padding. Enforces correct
 * length!
 */
export const DEVICE_LINKING_CODE_FORM_VALIDATION_REGEX = /^[A-Z2-7]{10}$/u;

/** Minimum length for the search input fields. */
export const SEARCH_STRING_MIN_LENGTH = 2;

/** Maximum length for the search input fields. */
export const SEARCH_STRING_MAX_LENGTH = 25;

/** Minimum length for the use group name. */
export const USER_GROUP_NAME_MIN_LENGTH = 3;

/** Database mandated maximum length for the use group name. */
export const USER_GROUP_NAME_MAX_LENGTH = 99;

/** Maximum length for the device name. */
export const DEVICE_NAME_MAX_LENGTH = 99;

/** Minimum length for the device name. */
export const DEVICE_NAME_MIN_LENGTH = 1;

/** Maximum length for the device location. */
export const DEVICE_LOCATION_MAX_LENGTH = 255;

/** Minimum length for the device location. */
export const DEVICE_LOCATION_MIN_LENGTH = 0;

/** The maximum size for the latitude number. */
export const DEVICE_LATITUDE_MIN = -90;

/** The minimum size for the latitude number. */
export const DEVICE_LATITUDE_MAX = 90;

/** The maximum size for the longitude number. */
export const DEVICE_LONGITUDE_MIN = -180;

/** The minimum size for the longitude number. */
export const DEVICE_LONGITUDE_MAX = 180;

/** Regex for validating UrlId parameter. */
export const URL_ID_VALIDATION_REGEX = /^[a-zA-Z0-9_-]{16}$/u;

/**
 * JSON Schema `pattern` for a comma-separated list of urlIds (16 chars each), or empty. Query
 * parameters are strings; JSON array syntax does not parse as a string array in Fastify.
 */
export const COMMA_SEPARATED_URL_IDS_REGEX = /^$|^([a-zA-Z0-9_-]{16})(,[a-zA-Z0-9_-]{16})*$/u;

/** Regex for phone MSISDN phone number format. */
export const MSISDN_VALIDATION_REGEX = /^\d{8,15}$/u;

/** Maximum length for a device map name. */
export const DEVICE_MAP_NAME_MAX_LENGTH = 99;

/** Minimum length for a device map name. */
export const DEVICE_MAP_NAME_MIN_LENGTH = 3;

/** Maximum width or height in pixels for the image used for device maps. */
export const DEVICE_MAP_IMAGE_MAXIMUM_DIMENSION = 10_000;

/** Maximum filesize in bytes for the image used for device maps. */
export const DEVICE_MAP_IMAGE_MAXIMUM_FILESIZE_BYTES = 10_000_000;